var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { apolloClient } from '../ApolloClient';
import { AddUserReportBugDocument, AddUserShareLinkDocument, useAddUserReportBugMutation } from '../models/GQLGeneratedModels';
import { getConfigitCriteria } from './AssemblySearchAPIService';
export var getNewReportId = function (reason, extraNotes, userEmail, urlPath) { return __awaiter(void 0, void 0, void 0, function () {
    var userReportBug, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                userReportBug = { SearchCriteriaData: 'test search data', Reason: reason, ExtraNotes: extraNotes, UserEmail: userEmail, UrlPath: urlPath };
                return [4 /*yield*/, insertUserReportBug(userReportBug)];
            case 1:
                result = _a.sent();
                console.log(result);
                return [2 /*return*/];
        }
    });
}); };
export var getBugReportId = function (layers, variableAssignments, excludedLayerTypeIds, manufacturerProduct, limit, offset, orderBy, reason, extraNotes, userEmail, urlPath) { return __awaiter(void 0, void 0, void 0, function () {
    var configitCriteria, configitCriteriaString, userReportBug, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                configitCriteria = getConfigitCriteria(layers, variableAssignments, excludedLayerTypeIds, manufacturerProduct, limit, offset, orderBy);
                configitCriteriaString = JSON.stringify(configitCriteria);
                userReportBug = { SearchCriteriaData: btoa(configitCriteriaString), Reason: reason, ExtraNotes: extraNotes, UserEmail: userEmail, UrlPath: urlPath };
                return [4 /*yield*/, insertUserReportBug(userReportBug)];
            case 1:
                result = _a.sent();
                console.log(result);
                return [2 /*return*/];
        }
    });
}); };
export var addUserReportBug = function (reason, extraNotes, userEmail, UrlPath) { return __awaiter(void 0, void 0, void 0, function () { var userReportBug; return __generator(this, function (_a) {
    userReportBug = { SearchCriteriaData: 'test search data', Reason: reason, ExtraNotes: extraNotes, UserEmail: userEmail };
    return [2 /*return*/, useAddUserReportBugMutation({ variables: { UserReportBug: userReportBug } })];
}); }); };
export var insertUserReportBug = function (userReportBug) { return __awaiter(void 0, void 0, void 0, function () {
    var _result$data, _result$data$insert_U, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apolloClient.mutate({ mutation: AddUserReportBugDocument, variables: { UserReportBug: userReportBug } })];
            case 1:
                result = _a.sent();
                //return result.data?.insert_UserReportBug?.returning[0].ReportBugId;
                return [2 /*return*/, (_result$data = result.data) === null || _result$data === void 0 ? void 0 : (_result$data$insert_U = _result$data.insert_UserReportBug) === null || _result$data$insert_U === void 0 ? void 0 : _result$data$insert_U.returning[0].ReportBugGuid];
        }
    });
}); };
export var getShareLinkId = function (layers, variableAssignments, excludedLayerTypeIds, manufacturerProduct, limit, offset, orderBy, userGuid) { return __awaiter(void 0, void 0, void 0, function () { var configitCriteria, configitCriteriaString, userShareLink, shareLinkGuid; return __generator(this, function (_a) {
    switch (_a.label) {
        case 0:
            configitCriteria = getConfigitCriteria(layers, variableAssignments, excludedLayerTypeIds, manufacturerProduct, limit, offset, orderBy);
            configitCriteriaString = JSON.stringify(configitCriteria);
            userShareLink = { SearchCriteriaData: btoa(configitCriteriaString), UserGuid: userGuid };
            return [4 /*yield*/, insertUserShareLink(userShareLink)];
        case 1:
            shareLinkGuid = _a.sent();
            return [2 /*return*/, shareLinkGuid];
    }
}); }); };
export var insertUserShareLink = function (userShareLink) { return __awaiter(void 0, void 0, void 0, function () { var _result$data2, _result$data2$insert_, result; return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, apolloClient.mutate({ mutation: AddUserShareLinkDocument, variables: { UserShareLink: userShareLink } })];
        case 1:
            result = _a.sent();
            return [2 /*return*/, (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : (_result$data2$insert_ = _result$data2.insert_UserShareLink) === null || _result$data2$insert_ === void 0 ? void 0 : _result$data2$insert_.returning[0].ShareLinkGuid];
    }
}); }); };
